const state = {
  actionType: null,
  userId: null,
  clinicId: null,
  email: null,
  tokenId: null,
  gradiantStyle: 'sdsds'
}

const actions = {
  setVerifyData ({ commit }, payload) {
    commit('SET_VERIFY_DATA', payload)
  }
}

const mutations = {
  SET_VERIFY_DATA (state, payload) {
    state.actionType = payload.actionType
    state.userId = payload.userId
    state.clinicId = payload.clinicId
    state.email = payload.email
    state.tokenId = payload.tokenId
  },
  // example
  SET_STATE (state, { key, value }) {
    state[key] = value
  }
}

const getters = {
  verifyData: (state) => ({ ...state }),
  actionType: (state) => state.actionType,
  gradiantStyle: (state) => state.gradiantStyle
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
